import { FormControl, FormGroup } from '@angular/forms';
import { SharedUtilitiesModule } from '../../utilities/shared-utilities.module';
import { SearchModelV2 } from '../../models/search-model-v2';
import * as moment from "moment";
import { SharedUtilitiesHelperFunctions } from '../../utilities/helper-functions';

export const agingriodPeriodSearchModel: SearchModelV2 = {
  label: {
    createdDate: 'Created Date',
  },
  dataType: {
    createdDate: 'date',
  },

  form: new FormGroup({
    createdDate: new FormGroup({
      from: new FormControl(SharedUtilitiesHelperFunctions.getDateNoTime(moment().subtract(1, 'month'))),
      to: new FormControl(SharedUtilitiesHelperFunctions.getTodayNoTime())
    })
  }),

  options: {
    createdDate: {'checkbox': false},
  },

};
